import { api, apiStore } from '@sh/services/api';

const backendApi = {
  trafficSources: {},
  campaigns: {},
  reporting: {},
};

backendApi.trafficSources = {
  types() {
    return apiStore.trafficSources.types();
  },
  account(id) {
    return api.trafficSources.account(id);
  },
  accounts() {
    return apiStore.trafficSources.accounts();
  },
};
backendApi.campaigns = {
  all() {
    return api.campaigns.all();
  },
};
backendApi.reporting = {
  get(trafficSourceType, reportType, campaignIds, startDate, endDate) {
    return api.reporting.get(trafficSourceType, reportType, campaignIds, startDate, endDate);
  },
  backgroundReporting(reportType) {
    return api.reporting.backgroundReporting(reportType);
  },
};

export default backendApi;
